(function () {
  'use strict';

  angular
    .module('app.page-maintenance-events', []);
})();
